import { defineVariants } from 'zl-shared/dist/ab-test';

const EXPERIMENTS = {
  control: {
    name: 'control',
    variants: [
      { name: 'a', weight: 1 },
      { name: 'b', weight: 1 },
    ],
  },
  annualPriceChange: {
    name: 'annual_price_change_202505',
    variants: [
      { name: 'c', weight: 1 },
      { name: 'd', weight: 1 },
      // reminder: later when we wanna stop the experiment, just keep the "mainVariant : c" field in the stripe
      // dashboard prices and remove the whole "variant: c" field from the stripe dashboard prices ( Both Monthly and Yearly prices ).
      // Prices without a "variant" field will be considered as default price, so the "mainVariant" means deafult price
    ],
  },
} as const;

Object.values(EXPERIMENTS).forEach((experiment) => {
  defineVariants(
    experiment.name,
    experiment.variants.map((v) => v.name),
    experiment.variants.map((v) => v.weight),
  );
});

export type ExperimentKey = keyof typeof EXPERIMENTS;

type VariantOfExperiment<T extends ExperimentKey> = (typeof EXPERIMENTS)[T]['variants'][number]['name'];
export type ControlTestVariant = VariantOfExperiment<'control'>;
export type AnnualPriceChangeVariant = VariantOfExperiment<'annualPriceChange'>;

export default EXPERIMENTS;
